export default { sha: 'fbeda32a2ce01628848158135aec6f86f25021ff', buildNumber: 'undefined' }
